/**
 * Normalizes an API error response body into a flat list of human-readable
 * messages. Used for the activation 422 (TASKS.md: "activating via PUT
 * /campaigns/{id} {status:'active'} returns 422 with errors if mapping
 * invalid") whose `errors` may be either the mapping validator's flat
 * `string[]` (matching `SaveCampaignMappingResponse.errors`) or Laravel's
 * standard per-field `{ field: string[] }` validation shape.
 */
export function extractErrorMessages(errorBody: unknown): string[] {
    if (!errorBody || typeof errorBody !== 'object') return [];

    const errors = (errorBody as { errors?: unknown }).errors;

    if (Array.isArray(errors)) {
        return errors.filter((item): item is string => typeof item === 'string');
    }

    if (errors && typeof errors === 'object') {
        return Object.values(errors as Record<string, unknown>).flatMap(value => {
            if (Array.isArray(value)) {
                return value.filter((item): item is string => typeof item === 'string');
            }
            return typeof value === 'string' ? [value] : [];
        });
    }

    const message = (errorBody as { message?: unknown }).message;
    return typeof message === 'string' ? [message] : [];
}
